import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

const initialState: any = {
  kitchenIndent: [],
  mogsData: [],
  aplsData: [],
  loading: false,
  error: null,
};


export const fetchKitchenIndent = createAsyncThunk(
  'kitchenIndent/fetchKitchenIndent',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/KitchenIndent/GetKitchenIndent`, payload);
    return response?.data?.data?.kitchensectionlist;
  }
);

export const saveKitchenIndent = createAsyncThunk(
  'kitchenIndent/saveKitchenIndent',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/KitchenIndent/SaveKitchenIndent`, payload);
    return response?.data;
  }
);

export const submitKitchenIndent = createAsyncThunk(
  'kitchenIndent/submitKitchenIndent',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/KitchenIndent/SubmitKitchenIndent`, payload);
    return response?.data;
  }
);

export const fetchMogs = createAsyncThunk(
  'kitchenIndent/fetchMogs',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/KitchenIndent/GetMOG`, payload);
    return response?.data?.data?.mogs;
  }
);

export const fetchApls = createAsyncThunk(
  'kitchenIndent/fetchApls',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/KitchenIndent/GetAPL`, payload);
    return response?.data?.data?.apls;
  }
);

export const addMog = createAsyncThunk(
  'kitchenIndent/addMog',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/KitchenIndent/AddMog`, payload);
    return response?.data;
  }
);

export const removeMog = createAsyncThunk(
  'kitchenIndent/removeMog',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/KitchenIndent/RemoveMog`, payload);
    return response?.data;
  }
);

const kitchenIndentSlice = createSlice({
  name: 'KitchenIndent',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchKitchenIndent.fulfilled, (state, action) => {
        //state.loading = false;
        state.kitchenIndent = action.payload; // Assuming the payload is an array of menu plans
      })
      .addCase(fetchKitchenIndent.rejected, (state, action) => {
        //state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchMogs.fulfilled, (state, action) => {

        state.mogsData = action.payload; // Assuming the payload is an array of menu plans
      })
      .addCase(fetchMogs.rejected, (state, action) => {
        state.error = action.error.message;
      });
    builder
      .addCase(saveKitchenIndent.fulfilled, (state, action) => {
        // state.loading = false;
        state.kitchenIndent = action.payload?.data?.kitchensectionlist; // Assuming the payload is an array of menu plans
      })
      .addCase(saveKitchenIndent.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default kitchenIndentSlice.reducer;
